export interface Photo {
  id: string;
  url: string;
  caption: string;
  date: string;
}

export interface Song {
  id: string;
  title: string;
  artist: string;
  url: string;
  coverUrl?: string;
}

export enum UploadType {
  PHOTO = 'photo',
  MUSIC = 'music'
}